import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminhomedash',
  templateUrl: './adminhomedash.component.html',
  styleUrls: ['./adminhomedash.component.css']
})
export class AdminhomedashComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
